<script>
import options from "./ImageGallery.options";
export default options;
</script>

<template>
  <article class="kb-image-gallery" :class="{ 'kb-image-gallery--hide': mobileSlider }">
    <template v-if="activeImg">
      <figure class="kb-image-module" :class="'kb-image-module--' + imgRatio" @click="showMultiple">
        <div class="kb-image-module__image-container">
          <picture class="kb-image-module__image">
            <source :srcset="`${activeImg.src}?io=${transformationDesktop}`" media="(min-width:475px)" />
            <source :srcset="`${activeImg.src}?io=${transformationMobile}`" media="(max-width:475px)" />
            <img :alt="activeImg.alt ?? ''" />
          </picture>
        </div>
      </figure>
    </template>

    <template v-if="imgs.length > 1">
      <ul class="kb-image-gallery__thumbnail-list">
        <template v-for="(img, index) in imgs" :key="index">
          <li class="kb-image-gallery__thumbnail-list-item">
            <figure :class="'kb-image-module kb-image-module--' + imgRatio">
              <div class="kb-image-module__image-container">
                <picture class="kb-image-module__image" @click="() => updateActiveImg(img)">
                  <source :srcset="`${img.src}?io=${transformationDesktop}`" media="(min-width:475px)" />
                  <source :srcset="`${img.src}?io=${transformationMobile}`" media="(max-width:475px)" />
                  <img :alt="img.alt" />
                </picture>
              </div>
            </figure>
          </li>
        </template>
      </ul>
    </template>
  </article>

  <template v-if="imgs.length > 1">
    <div class="kb-image-gallery__slider" :class="{ 'kb-image-gallery__slider--hide': !mobileSlider }">
      <div class="glide kb-image-gallery__glide" id="imageGalleryGlideId">
        <div class="glide__track kb-image-gallery__glide__track" data-glide-el="track">
          <ul class="glide__slides">
            <template v-for="(img, index) in imgs" :key="index">
              <li class="kb-image-gallery__slider__content glide__slide">
                <figure :class="'kb-image-module kb-image-module--' + imgRatio">
                  <div class="kb-image-module__image-container">
                    <picture class="kb-image-module__image" @click="() => updateActiveImg(img)">
                      <source :srcset="`${img.src}?io=${transformationDesktop}`" media="(min-width:475px)" />
                      <source :srcset="`${img.src}?io=${transformationMobile}`" media="(max-width:475px)" />
                      <img :alt="img.alt" />
                    </picture>
                  </div>
                </figure>
              </li>
            </template>
          </ul>
        </div>

        <ul data-glide-el="controls[nav]" class="kb-image-gallery__glide-controls glide__bullets">
          <template v-for="(img, index) in imgs" :key="index">
            <li class="glide__bullet" :data-glide-dir="`=${index}`">
              <svg width="6" height="6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="3" cy="3" r="3" fill="#3C3C3C" />
              </svg>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </template>

  <template v-if="imgs.length === 1">
    <figure class="kb-image-module" :class="[
      'kb-image-module--' + imgRatio,
      { 'kb-image-gallery__slider--hide': !mobileSlider },
    ]">
      <div class="kb-image-module__image-container">
        <picture class="kb-image-module__image">
          <source :srcset="`${activeImg.src}?io=${transformationDesktop}`" media="(min-width:475px)" />
          <source :srcset="`${activeImg.src}?io=${transformationMobile}`" media="(max-width:475px)" />
          <img :alt="activeImg.alt ?? ''" />
        </picture>
      </div>
    </figure>
  </template>

  <vue-easy-lightbox :visible="visibleRef" :imgs="imgsRef" :index="indexRef" @hide="onHide" :loop="true"
    @on-open="localizeToolbar">
    <template v-slot:prev-btn="{ prev }">
      <button @click="prev"
        class="kb-image-module__lightbox-controls-chevron kb-image-module__lightbox-controls-chevron-prev"
        aria-label="Forrige">
        <!-- prettier-ignore -->
        <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m15 12.5 4 4-4 4" stroke="#3C3C3C" stroke-width="1.5" stroke-linejoin="round" />
          <circle cx="16" cy="16.5" r="15.25" stroke="#3C3C3C" stroke-width="1.5" />
        </svg>
      </button>
    </template>

    <template v-slot:next-btn="{ next }">
      <button @click="next"
        class="kb-image-module__lightbox-controls-chevron kb-image-module__lightbox-controls-chevron-next"
        aria-label="Næste">
        <!-- prettier-ignore -->
        <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="m15 12.5 4 4-4 4" stroke="#3C3C3C" stroke-width="1.5" stroke-linejoin="round" />
          <circle cx="16" cy="16.5" r="15.25" stroke="#3C3C3C" stroke-width="1.5" />
        </svg>
      </button>
    </template>

    <template v-slot:close-btn="{ close }">
      <button @click="close" class="kb-image-module__lightbox-controls-close" aria-label="Luk">
        <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="m1.354 21.354 20-20-.707-.708L11 10.293 1.354.646l-.708.708L10.293 11 .646 20.646l.708.707Zm20-.708-7.5-7.5-.707.707 7.5 7.5.707-.707Z"
            fill="#3C3C3C" />
        </svg>
      </button>
    </template>


    <!-- Originates in vue-easy-lightbox, modifying these do nothing-->
    <!-- <template v-slot:toolbar="{ toolbarMethods }">
      <div class="vel-toolbar">
        <button class="toolbar-btn toolbar-btn__zoomin" @click="toolbarMethods.zoomIn">
          <svg class="vel-icon icon" aria-hidden="true"><use xlink:href="#icon-zoomin"></use></svg>
        </button>
        <button class="toolbar-btn toolbar-btn__zoomout" @click="toolbarMethods.zoomOut">
          <svg class="vel-icon icon" aria-hidden="true"><use xlink:href="#icon-zoomout"></use></svg>
        </button>
        <button class="toolbar-btn toolbar-btn__resize" @click="toolbarMethods.resize">
          <svg class="vel-icon icon" aria-hidden="true"><use xlink:href="#icon-resize"></use></svg>
        </button>
        <button class="toolbar-btn toolbar-btn__rotate" @click="toolbarMethods.rotateLeft">
          <svg class="vel-icon icon" aria-hidden="true"><use xlink:href="#icon-rotate-left"></use></svg>
        </button>
        <button class="toolbar-btn toolbar-btn__rotate" @click="toolbarMethods.rotateRight">
          <svg class="vel-icon icon" aria-hidden="true"><use xlink:href="#icon-rotate-right"></use></svg>
        </button>
      </div>
    </template> -->
  </vue-easy-lightbox>
</template>